import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ChargingStation } from '@models/charging-station';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DeleteChargingStationDialogContentComponent } from './delete-charging-station-dialog-content/delete-charging-station-dialog-content.component';

@Component({
  selector: 'app-delete-charging-station-dialog',
  template: ''
})
export class DeleteChargingStationDialogComponent implements OnInit {

  private chargingStationId: string;

  constructor(public dialog: NgbModal, private activatedRoute: ActivatedRoute, private router: Router) { }

  ngOnInit() {
    this.activatedRoute.paramMap.subscribe(params => {
      if (this.chargingStationId == null) {
        this.chargingStationId = params.get('key');
      }
      this.openDialog();
    });
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(DeleteChargingStationDialogContentComponent, { centered: true, backdrop: 'static' });
    dialogRef.componentInstance.chargingStationId = this.chargingStationId;

     dialogRef.result.then((result) => {
       this.router.navigate(['../../'], { relativeTo: this.activatedRoute });
     }, (backdrop) => {
       this.router.navigate(['../../'], { relativeTo: this.activatedRoute });
     });
  }

}
